import { Link, Navigate } from 'react-router-dom';

import { Anchor, Space, Text, Title } from '@mantine/core';

import useAuth from '@hooks/useAuth';

import LoginForm from '@components/LoginForm';
import { useEffect } from 'react';

export default function Login() {
  // ==========================================================================
  // General
  // ==========================================================================
  const { isAuthenticated, user, logout } = useAuth();

  useEffect(() => {
    if (isAuthenticated && user?.role === 'customer') {
      void logout();
    }
  }, [isAuthenticated, user?.role, logout]);

  // ==========================================================================
  // Render
  // ==========================================================================
  if (isAuthenticated && user?.role === 'customer') {
    return null;
  }

  return isAuthenticated ? (
    <Navigate to="/clienti" replace={true} />
  ) : (
    <>
      <Title ta="center" fz={{ base: '1.35rem', sm: '1.8rem' }} mt="md" px="xs">
        Accedi
      </Title>
      <Text ta="center" size="sm" px="xs" style={{ wordBreak: 'break-word' }}>
        Non hai ancora un account?{' '}
        <Anchor to="/registrati" component={Link}>
          Crea account
        </Anchor>
      </Text>

      <Space h="xl" />

      <LoginForm />
    </>
  );
}
